import { api } from './index';

const QuoteRequestService = {
  getAll: async(params) => {
      return await api.get('quote-request', params);
  },
  getQuote: async(id) => {
      return await api.get(`quote-request/${id}`);
  },
  setComments: async({ id, comments }) => {
      return await api.put(`quote-request/${id}/save-comments`, { comments });
  },
  getQuotesGroupedByDay: async ({ params }) => {
    return await api.get('quote-request/chart', {
      params,
    });
  },
  getReportByStatus: async({ params }) => {
    return await api.get('quote-request/report-leads-by-status', { params });
  },
  getReportLogError: async({ params }) => {
    return await api.get('quote-request/report-log-error', { params });
  },
  update:async(id) => {
    return await api.put(`quote-request/${id}`);
  }
};

export default QuoteRequestService;
